
export default function text2Cards () {

	const swipers = document.querySelectorAll('section.text-2-cards .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');
		new Swiper (container, {
			loop: false,
			breakpoints: {
				0:    { slidesPerView: 1 },
				768:  { slidesPerView: 2, spaceBetween: 20 },
				1360: { slidesPerView: 2, spaceBetween: 32 },
			},
			pagination: {
				el: section.querySelector('.swiper-pagination'),
				type: 'progressbar',
			},
			navigation: {
				prevEl: section.querySelector('.swipe-prev'),
				nextEl: section.querySelector('.swipe-next'),
			},
		});

	});

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too. ACF's block-preview JS runs in the outer
	admin window, while this script runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=text-2-cards', text2Cards);
}
